module.exports = __webpack_public_path__ + "img/sit_reach.a7bae04f.svg";